module.exports = __webpack_public_path__ + "static/media/Oversize-Cargoes.aa5a37a5.jpg";